import * as _ from "lodash";
import { TranslateService } from "@ngx-translate/core";
import { EntityQuery } from "../interface/EntityQuery"
import { NzModalService } from "ng-zorro-antd/modal";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { PreferenceService } from "../services/system/preference.service";
import { TenantCustomService } from "../services/system/tenant-custom.service";
import * as moment_ from 'moment';
import { CustomFieldsService } from "../services/system/custom-fields.service";
import { ChangeDetectorRef } from "@angular/core";
const moment = moment_;

// 所有 mixins 都需要

// 定义一个函数
// () => T
// 该函数没有输入参数，返回一个对象(<T = {}>)
// (...args: any[]) => T
// ...args: any[]使用的是Rest Parameters构造，该构造本质上表示可以提供any类型的任何数量的参数。
// 因为存在数量未知的any参数，所以参数的类型是any的数组。最后，把 new 关键字补上。
// new (...args: any[]) => T
// 此处的new关键字指定可以将此函数视为类构造函数，并使用new关键字进行调用。
// 该函数是一个可以接受返回对象类型的任意数量的参数(类型为any的函数)，并且可以用作带有new关键字的构造函数。
type Constructor<T = {}> = new (...args: any[]) => T;

/////////////
// mixins 例子
////////////

class BaseComponent {
  componentName = 'base';
}

// 多语装饰器
export function TranslatePoolSupport<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    translate: TranslateService;

    setTranslateService(translateS: TranslateService) {
      this.translate = translateS;
    }

    loadCommonTranslation(translateS?: TranslateService) {
      if (translateS) {
        this.setTranslateService(translateS);
      }
    }
  };
}

// 数据选取装饰器
export function DataSelectSupport<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    listOfDisplayData = [];
    isAllDisplayDataChecked = false;
    isIndeterminate = false;
    mapOfCheckedId: { [key: string]: boolean } = {};
    numberOfChecked = 0;

    refreshStatus(): void {
      this.isAllDisplayDataChecked = this.listOfDisplayData
        .filter(item => !item.disabled)
        .every(item => this.mapOfCheckedId[item.id]);
      this.isIndeterminate =
        this.listOfDisplayData.filter(item => !item.disabled).some(item => this.mapOfCheckedId[item.id]) &&
        !this.isAllDisplayDataChecked;
      this.numberOfChecked = this.listOfDisplayData.filter(item => this.mapOfCheckedId[item.id]).length;
    }

    checkAll(value: boolean): void {
      this.listOfDisplayData.filter(item => !item.disabled).forEach(item => (this.mapOfCheckedId[item.id] = value));
      this.refreshStatus();
    }

    checkByIds(ids: any[]) {
      if (ids) {
        this.mapOfCheckedId = {};
        ids.forEach(id => this.mapOfCheckedId[id] = true);
      }
    }
    checkByItems(items: any[]) {
      if (items) {
        const ids = items.map(item => item.id);
        this.checkByIds(ids);
      }
    }

    getCheckedData() {
      return this.listOfDisplayData
        .filter(item => !item.disabled && this.mapOfCheckedId[item.id]);
    }

    getConvertedTime(time) {
      if (time !== undefined) {
        return moment().startOf('d').add(time, 'm').valueOf();
      } else {
        return null;
      }
    }
  };
}

// 增删改查装饰器
export function EntityManagementSupport<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    modalContent;
    modalContentFooter;
    baseModal;
    // 数据变更
    cdr: ChangeDetectorRef;
    // 多语
    translateService: TranslateService;
    // 偏好设置
    basePreferenceService: PreferenceService;
    // 自定义字段设置
    baseTenantCustomService: TenantCustomService;
    // 自定义字段处理
    baseCustomFieldsService: CustomFieldsService;
    // 实体通用service
    entityService: EntityQuery;
    // 消息通知
    notification;
    // 加载中
    loading = false;
    // 列表
    dataList;
    // 新增 修改 查看 删除成功 删除失败 保存成功
    labelAdd;
    labelModify;
    labelShow;
    labelDeleteFailed;
    labelDeleteSuccess;
    labelSaveSuccess;
    // 模态框service
    modalService: NzModalService;
    // 实体对象
    detailItem: any;
    // 实体formGroup
    detailForm: FormGroup;
    // 单据校验
    validation: any = {
      'fieldName': {
        'required': '必填'
      }
    }
    // 实例显示名称,模态框标题
    entityDisplayName = '';
    // 实例名称  实体表名称，加载自定义字段
    entityName = '';
    tableName = '';
    bodyEntityName = '';
    bodyTableName = '';

    //动态列
    dynamicColumn = false;
    // 显示列设置名称
    columnSettingName = ''; //正常打开以entityName设定显示，开窗调用时以columnSettingName设定显示
    // 实体键值名称,通用删除接口RESTFUL请求{id}
    primaryKeyName = 'id';
    // 模态框默认宽度
    modalWidth = 1000;
    // 模态框默认标题
    modalTitle;
    // 页码
    pageNum = 1;
    // 每页的条数 
    pageSize = 10;
    // 总条数
    total = 0;
    // 查询参数
    queryParams = {}
    queryParamKey;
    // 显示列设置
    columnSettings;
    bodyColumnSettings
    // 偏好设置
    pickedColumnSettings;
    bodyPickedColumnSettings;
    // 自定义字段设置
    customFieldSettings = {
      master: {
        fields: []
      },
      detail: {
        fields: []
      }
    };
    // 自定义字段标题栅格占位格数
    labelSpan = 4
    // 自定义字段控件栅格占位格数
    controlSpan = 18

    add() {
      // this.detailItem = {};
      this.modalTitle = this.labelAdd + this.entityDisplayName;
      this.buildForm();
      this.controlSubscribe(this.detailForm)
      this.buildCustomFieldsGroup(this.detailForm, this.customFieldSettings.master);
      const item = this.dataProcessBeforeAdd(this.detailForm.getRawValue());
      this.objectToFormGroup(item);
      this.showDetail();
      this.detailForm.enable();
    }

    async modify(item) {
      item = await this.entityService.getById(item[this.primaryKeyName]).toPromise();
      if (!item[this.primaryKeyName]) {
        console.log('弹窗不显示原因：键值不存在！')
        return;
      }

      this.addModifyManagementField(item)
      this.modalTitle = this.labelModify + this.entityDisplayName;
      this.dataProcessAfterGetData(item);
      this.objectToFormGroup(item);
      this.buildCustomFieldsGroup(this.detailForm, this.customFieldSettings.master, item);
      this.showDetail();
      this.detailForm.enable();
    }


    controlSubscribe(formGroup) {
      if (!formGroup) {
        return;
      }
      for (const item in formGroup.controls) {
        if (this.validation[item]) {
          formGroup.controls[item].valueChanges.subscribe(data => this.onValueChanged(formGroup, item));
        }
      }
    }

    takeValueChanged() {
      for (const i in this.detailForm.controls) {
        if (this.validation[i]) {
          this.onValueChanged(this.detailForm, i)
        }
      }
      if (this.bodyFormArray) {
        for (const i in this.bodyFormArray.controls) {
          let formGroup = this.bodyFormArray.controls[i] as FormGroup;
          for (const j in formGroup.controls) {
            if (this.validation[j]) {
              this.onValueChanged(formGroup, j)
            }
          }
        }
      }
    }

    onValueChanged(formGroup: any, field: any) {
      if (!formGroup || !field) return;
      const control = formGroup.get(field);
      control.customErrorMessages = '';
      if (control && !control.valid) { //&& control.dirty
        const validate = this.validation[field];
        for (const key in control.errors) {
          control.customErrorMessages += validate[key] + '\n';
        }
      }
    }

    addModifyManagementField(item) {
      if (!this.detailForm.controls[this.primaryKeyName])
        this.detailForm.addControl(this.primaryKeyName, new FormControl(''));
      if (!this.detailForm.controls['updateTime'])
        this.detailForm.addControl('updateTime', new FormControl(''));
      if (!this.detailForm.controls['tenantId'])
        this.detailForm.addControl('tenantId', new FormControl(''));
      if (!this.detailForm.controls['custom'])
        this.detailForm.addControl('custom', new FormControl(''));
    }

    async show(item) {
      item = await this.entityService.getById(item[this.primaryKeyName]).toPromise();
      if (!item[this.primaryKeyName]) {
        console.log('弹窗不显示原因：键值不存在！')
        return;
      }

      this.modalTitle = this.labelShow + this.entityDisplayName;
      this.dataProcessAfterGetData(item);
      this.objectToFormGroup(item);
      this.buildCustomFieldsGroup(this.detailForm, this.customFieldSettings.master, item);
      this.detailForm.disable();
      this.modalService.create({
        nzTitle: this.modalTitle,
        nzStyle: { top: '5px' },
        nzWidth: this.modalWidth,
        nzContent: this.modalContent,
        nzCancelText: null,
        nzOnOk: async () => {
          return true;
        }
      });
    }

    async remove(item) {
      try {
        const result = await this.entityService.remove(item, this.primaryKeyName).toPromise();
        if (result['code'] === 0) {
          this.afterRemoveSuccess();
          this.loadData();
          this.notification.success(this.labelDeleteSuccess, '');
        } else {
          this.notification.error(this.labelDeleteFailed, result['message']);
        }
      } catch (e) {
        this.notification.error(this.labelDeleteFailed, e);
      }
    }

    async showDetail(item?) {
      // this.detailItem = _.cloneDeep(item);
      // this.setSpan(this.customFieldSettings.master)
      this.baseModal = this.modalService.create({
        nzTitle: this.modalTitle,
        nzStyle: { top: '5px' },
        nzWidth: this.modalWidth,
        nzContent: this.modalContent,
        nzFooter: this.modalContentFooter ? this.modalContentFooter : '',
        nzOnOk: async () => {
          return await this.saveData()
        },
        nzOnCancel: async () => {
          this.baseModal.destroy();
        }
      });
    }

    handleCancel() {
      this.baseModal.destroy()
      this.loading = false
    }

    objectToFormGroup(item) {
      this.detailForm.reset();
      this.detailForm.patchValue(item)
      for (const key in item) {
        if (item.hasOwnProperty(key) && Array.isArray(item[key]) && item[key].length > 0 && key != 'customFields') {
          const formArray = this.detailForm.controls[key] as FormArray;
          if (formArray instanceof FormArray) {
            formArray.clear();
            item[key].forEach(detail => {
              const formGroup = this.buildDetailForm();
              this.controlSubscribe(formGroup);
              if (formGroup) {
                this.buildCustomFieldsGroup(formGroup, this.customFieldSettings.detail, detail);
                if (!formGroup.controls['updateTime'])
                  formGroup.addControl('updateTime', new FormControl(''));
                formGroup.patchValue(detail)
                formArray.push(formGroup);
              }
            });
          }
        }
      }
    }

    // 组装自定义字段FormGroup
    buildCustomFieldsGroup(formGroup, customFieldSettings, item?) {
      if (!customFieldSettings) {
        return;
      }
      this.renewCustomFieldSettings(customFieldSettings);
      this.baseCustomFieldsService.changeToCustomEdit(item ? item.custom : {}, customFieldSettings.fields, customFieldSettings.fields)

      const fb = new FormBuilder();
      if (!formGroup.get('customFields')) {
        formGroup.addControl('customFields', fb.array([]))
      }
      const customFieldFromArray = formGroup.get('customFields') as FormArray;
      customFieldFromArray.clear();
      let customFieldFormGroup;
      customFieldSettings.fields.forEach(item => {
        customFieldFormGroup = fb.group({
          fieldId: [item.fieldId, [Validators.required]],
          fieldName: [item.fieldName, [Validators.required]],
          fieldType: [item.fieldType, [Validators.required]],
          fieldExtend: [item.fieldExtend, [Validators.required]]
        });
        if (item?.fieldExtend?.required) {
          customFieldFormGroup.addControl('fieldValue', new FormControl(item?.fieldExtend?.defaultValue, [Validators.required]));
        } else {
          customFieldFormGroup.addControl('fieldValue', new FormControl(item?.fieldExtend?.defaultValue, []));
        }
        customFieldFromArray.push(customFieldFormGroup);
      });
      customFieldFromArray.patchValue(customFieldSettings.fields)
    }


    // 前端自定义字段值转后端格式，单头单身自定义字段值写入custom属性
    changeToCustom(saveObj) {
      this.baseCustomFieldsService.changeToCustom(saveObj)
      for (const key in saveObj) {
        if (saveObj.hasOwnProperty(key) && Array.isArray(saveObj[key]) && saveObj[key].length > 0 && key == 'customFields') {
          saveObj[key].forEach(detail => {
            this.baseCustomFieldsService.changeToCustom(detail)
          });
        }
      }
    }

    async changeToCustomEdit(tableName, data) {
      if (!data) {
        return;
      }

      let customFieldSettings = await this.baseTenantCustomService.getmodelType(tableName).toPromise();
      if (customFieldSettings?.customId && customFieldSettings.fields) {
        this.baseCustomFieldsService.changeToCustomEdit(data ? data.custom : {}, customFieldSettings.fields, customFieldSettings.fields)
        data.fields = customFieldSettings.fields
      }
    }

    get bodyFormArray() {
      return this.detailForm.get(this.bodyEntityName) as FormArray;
    }

    addBody() {
      let formGroup = this.buildDetailForm();
      this.controlSubscribe(formGroup)
      this.buildCustomFieldsGroup(formGroup, this.customFieldSettings.detail);
      this.bodyFormArray.push(formGroup)
      return formGroup;
    }

    deleteBody(index) {
      this.bodyFormArray.removeAt(index)
    }

    // 自定义字段列表
    get customFields() {
      return this.detailForm.get('customFields') as FormArray;
    }

    getCustomFieldFormGroup(formGroup, index) {
      let tempFormGroup = formGroup.get('customFields') as FormArray;
      return tempFormGroup.controls[index] as FormGroup;
    }

    buildForm() {
      return;
    }

    buildDetailForm(): FormGroup {
      return;
    }

    async loadData() {
      await this.loadDataByPage();
    }

    async queryData($event) {
      this.pageNum = $event;
      this.loadData()
    }

    async loadDataByPage(queryParams?, orderProperty?, orderType?) {
      const queryOrderType = 'ascend' === orderType ? 'ASC' : 'DESC';
      if (queryParams) {
        this.queryParams = queryParams;
      } else {
        this.queryParams = {};
      }
      this.loading = true;
      try {
        const res: any = await this.entityService.getDataByPage2(this.pageNum, this.pageSize, this.queryParams, orderProperty, queryOrderType).toPromise();
        const data = res.data;
        this.loading = false;
        //预处理表格数据
        this.dataList = data['data'];
        this.dataProcessAfterLoadData(this.dataList);
        this.total = data['totalRecords'];
      } catch (e) {
        this.loading = false;
      }
    }

    async loadDataByPageIndex(pageIndex) {
      this.pageNum = pageIndex;
      this.loadDataByPage(this.queryParams);
    }

    queryParamChangeData(params) {
      const queryParams = this.getQueryParam(params);
      const currentQueryParamKey = Object.values(queryParams).join('_');
      if (currentQueryParamKey !== this.queryParamKey) {
        this.queryParamKey = currentQueryParamKey;
        this.pageNum = params.pageIndex;
        this.pageSize = params.pageSize;
        this.loadDataByPage(this.queryParams, queryParams.sortField, queryParams.sortOrder);
      }
    }

    getQueryParam(params) {
      const currentSort = params.sort.find(item => item.value !== null);
      const sortField = (currentSort && currentSort.key) || null;
      const sortOrder = (currentSort && currentSort.value) || null;
      return {
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
        sortField: sortField,
        sortOrder: sortOrder
      };
    }

    async checkBeforeSave() {
      return true
    }

    //预处理表格数据
    dataProcessAfterLoadData(dataList) {
      dataList.forEach(item => {
        if (item.custom){
          Object.keys(item.custom).forEach(key=>item['customField-'+key]=item.custom[key])
        }
      });
      return dataList;
    }

    dataProcessBeforeAdd(item) {
      return item
    }

    dataProcessAfterGetData(item) {
      return item;
    }

    dataProcessBeforeSave(item) {
      this.deProcessTime(item);
      this.deProcessTimeData(item);
    }

    // 格式化日期
    parseDateTime(date) {
      if (!date) {
        return '-'
      } else {
        let arr = date.split('T')
        if (arr[0] && arr[1]) {
          return arr[0] + ' ' + arr[1]
        } else if (arr[0] && !arr[1]) {
          return arr[0]
        }
      }
    }
    // 格式化时间
    processTime(item) {
      for (let key in item) {
        if (key.endsWith('Time')) {
          item[key] = moment(item[key]).toDate();
        }
      }
    }

    deProcessTime(item) {
      for (let key in item) {
        if (key.endsWith('Time')) {
          item[key] = moment(item[key]).format("YYYY-MM-DDTHH:mm:ss");
        }
      }
    }

    processTimeData(item) {
      for (let key in item) {
        if (key.endsWith('StartTime')) {
          const timeFieldKey = key.substring(0, key.indexOf('StartTime'));
          const endTimeFieldKey = timeFieldKey + 'EndTime';
          item[timeFieldKey + 'TimeRange'] = [moment(item[key]).toDate(), moment(item[endTimeFieldKey]).toDate()];
        }
      }
      return item;
    }

    deProcessTimeData(item) {
      for (let key in item) {
        if (key.endsWith('TimeRange')) {
          const timeFieldKey = key.substring(0, key.indexOf('TimeRange'));
          const startTimeFieldKey = timeFieldKey + 'StartTime';
          const endTimeFieldKey = timeFieldKey + 'EndTime';
          item[startTimeFieldKey] = (item[key] && item[key][0]) ? moment(item[key][0]).format("YYYY-MM-DDTHH:mm:ss") : null;
          item[endTimeFieldKey] = (item[key] && item[key][1]) ? moment(item[key][1]).format("YYYY-MM-DDTHH:mm:ss") : null;
        }
      }
      return item;
    }

    renewCustomFieldSettings(customFieldSettings) {
      customFieldSettings.fields.forEach(item => {
        item.fieldValue = null
      });
    }

    setEntityService(service) {
      this.entityService = service;
    }

    setTranslateService(translateS: TranslateService) {
      this.translateService = translateS;
    }

    loadCommonTranslation(translateS?: TranslateService) {
      if (translateS) {
        this.setTranslateService(translateS);
      }
      this.labelAdd = this.translateService.instant('新增');
      this.labelModify = this.translateService.instant('编辑');
      this.labelShow = this.translateService.instant('查看');
      this.labelDeleteSuccess = this.translateService.instant('删除成功');
      this.labelDeleteFailed = this.translateService.instant('删除失败');
      this.labelSaveSuccess = this.translateService.instant('保存成功');
    }

    async loadCustomFieldSettings() {
      if (this.tableName)
        this.customFieldSettings.master = await this.baseTenantCustomService.getmodelType(this.tableName).toPromise() || { fields: [] }
      if (this.bodyTableName)
        this.customFieldSettings.detail = await this.baseTenantCustomService.getmodelType(this.bodyTableName).toPromise() || { fields: [] }

      this.customFieldSetWidth(this.customFieldSettings.master)
      this.customFieldSetWidth(this.customFieldSettings.detail)
    }

    customFieldSetWidth(customFieldSettings) {
      if (customFieldSettings && customFieldSettings.fields) {
        customFieldSettings.fields = customFieldSettings.fields.map(o => {
          switch (o.fieldType) {
            case 'Text':
              o.width = 183
              o.otherWidth = 176
              break;
            case 'Number':
              o.width = 128
              o.otherWidth = 120
              break;
            case 'Picture':
              o.width = 183
              o.otherWidth = 200
              break;
            case 'File':
              o.width = 183
              o.otherWidth = 200
              break;
            case 'Date':
              o.width = 132
              o.otherWidth = 120
              break;
            case 'Time':
              o.width = 116
              o.otherWidth = 90
              break;
            case 'DateTime':
              o.width = 182
              o.otherWidth = 154
              break;
            case 'Select':
              o.width = 183
              o.otherWidth = 200
              break;
            case 'MultiSelect':
              o.width = 183
              o.otherWidth = 200
              break;
          }
          return o
        })
        this.loading = false
      } else {
        this.loading = false
      }
    }

    async loadColumnSettings() {
      if (this.columnSettingName || this.entityName) {
        this.columnSettings = await this.basePreferenceService.getColumnSettings(this.columnSettingName ? this.columnSettingName : this.entityName).toPromise();
        this.basePreferenceService.getPickedColumns(this.columnSettingName ? this.columnSettingName : this.entityName).subscribe(settings => {
          this.pickedColumnSettings = settings;
        });
      }

      if (this.bodyEntityName) {
        this.bodyColumnSettings = await this.basePreferenceService.getColumnSettings(this.bodyEntityName).toPromise();
        this.basePreferenceService.getPickedColumns(this.bodyEntityName).subscribe(settings => {
          this.bodyPickedColumnSettings = settings;
        });
      }
    }

    savePreference(preference) {
      this.basePreferenceService.saveColumnSettings(this.columnSettingName ? this.columnSettingName : this.entityName, preference).subscribe(res => {
        if (res['data'] === 0) {
          this.notification.success(this.labelSaveSuccess, '');
        }
      })
    }

    async saveData(item?) {
      try {
        // for (const i in this.detailForm.controls) {
        //   this.detailForm.controls[i].markAsTouched();
        //   this.detailForm.controls[i].updateValueAndValidity();
        // }
        this.takeValueChanged()
        if (!await this.checkBeforeSave()) { return false; }
        if (this.detailForm.valid) {
          let saveObj = this.detailForm.getRawValue()
          this.dataProcessBeforeSave(saveObj)
          this.changeToCustom(saveObj)
          const result = await this.entityService.save(saveObj, this.primaryKeyName).toPromise();
          if (result['code'] === 0) {
            this.baseModal.destroy();
            this.notification.success(this.labelSaveSuccess, '');
            this.loadData();
            return result;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }

    afterRemoveSuccess() {
    }

    handleEmptyValue(value) {
      return value || '-'
    }

    setImgPath({ path, index }) {
      this.baseCustomFieldsService.setImgPath(this.detailItem.fields, { path, index })
    }

    //样式偏移
    setSpan(fields) {
      this.labelSpan = 4
      this.controlSpan = 18
      let max = 16
      if (fields && fields.length) {
        fields.forEach((o) => {
          if (o.fieldName) {
            let temp = this.getLength(o.fieldName)
            if (temp > max) {
              max = temp
            }
          }
        })
        this.labelSpan = 4 + Math.ceil((max - 16) / 8) < 16 ? 4 + Math.ceil((max - 16) / 8) : 16
        this.controlSpan = 88
      }
    }

    getLength(str) {
      var realLength = 0, len = str.length, charCode = -1;
      for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) realLength += 1;
        else realLength += 2;
      }
      return realLength;
    };
  };

}

///////////
// 组合类
///////////
export const TranslateSupported = TranslatePoolSupport(BaseComponent);
export const DataSelectSupported = DataSelectSupport(TranslatePoolSupport(BaseComponent));
export const BaseEntityManagementSupported = EntityManagementSupport(BaseComponent);
